import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { formatUrl } from "@utils/formatUrl";

let serverUrl = getSecret('SERVER_MASTER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERIDIC_TASKS_RESULTS(state, periodicTasksResults) {
    state.cached = periodicTasksResults
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchPeriodicTasksResults(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/scheduled_tasks/task_result/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_PERIDIC_TASKS_RESULTS', request)
      return request
    })
  },

  fetchPeriodicTasksResultsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdatePeriodicTasksResults(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formatUrl(formData.url), formData)
    }else {
      promise =  axios.post(`${serverUrl}/scheduled_tasks/task_result/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deletePeriodicTasksResults(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}